import { Box } from '@mui/material';
import { formatNumberForCurrency, getCurrencySymbol } from '../../helper';

const AmountCell = ({ data }: { data: number }) => {
  const color = data < 0 ? '#D63939' : '#2FB344';

  return (
    <Box sx={{ color: color, fontWeight: 500 }}>
      {data || data === 0 ? `${getCurrencySymbol('INR')} ${data}` : 'N/A'}
    </Box>
  );
};

export default AmountCell;